import { render, staticRenderFns } from "./show_embedded.vue?vue&type=template&id=19ade002&scoped=true&"
import script from "./show_embedded.vue?vue&type=script&lang=js&"
export * from "./show_embedded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ade002",
  null
  
)

export default component.exports